module.exports = __webpack_public_path__ + "img/sq.e88d5b0b.svg";